import wishlistMessages from '../../../utils/WishlistMessageConstants';
import { getWishlistAPIResponseMessage } from '../../../utils/handleWishlistMessages';
import { deleteProductAttributionToken } from '../../../utils/common'

export const getDeleteFromCartAndAddToWishlistMessage = (
  cartResponse,
  wishlistResponse,
  requestedBy
) => {
  const {
    DELETE_ITEM_REQUEST_FAILED_MESSAGE = '',
    FAILED_TO_MOVE_MESSAGE_FOR_OUTOFSTOCK_ITEM = '',
    FAILED_TO_MOVE_MESSAGE_FOR_INSTOCK_ITEM = ''
  } = wishlistMessages;

  const moveToWishListFailedMsg =
    requestedBy === 'viaProductCardWithRemoveOutOfStockOption'
      ? FAILED_TO_MOVE_MESSAGE_FOR_OUTOFSTOCK_ITEM
      : FAILED_TO_MOVE_MESSAGE_FOR_INSTOCK_ITEM;

  if (!cartResponse || cartResponse.statusCode || cartResponse.CAUGHT_API_ERROR === true) {
    return DELETE_ITEM_REQUEST_FAILED_MESSAGE;
  }
  if (!wishlistResponse || wishlistResponse.CAUGHT_API_ERROR === true) {
    return moveToWishListFailedMsg;
  }
  if (cartResponse && wishlistResponse) {
    return getWishlistAPIResponseMessage(wishlistResponse, requestedBy);
  }
  return '';
};

export const deleteFromCartAndAddToWishlist = function(
  addToWishlistApi,
  deleteCard,
  modalName,
  code,
  entryNumber,
  showErrorMessageInfo,
  requestedBy = '',
  position
) {
  const promiseArray = [
    addToWishlistApi(code, false).catch(err => {
      return { CAUGHT_API_ERROR: true, error: err };
    }),
    deleteCard(modalName, {
      entryNumber,
      code,
      showMessage: false,
      position
    }).catch(err => {
      return { CAUGHT_API_ERROR: true, error: err };
    })
  ];
  Promise.all(promiseArray)
    .then(values => {
      let message = '';
      let cartResponse;
      let wishlistResponse;
      [wishlistResponse, cartResponse] = values;
      message = getDeleteFromCartAndAddToWishlistMessage(
        cartResponse,
        wishlistResponse,
        requestedBy
      );

      if (message) {
        const messageBar = {
          errorType: 'info',
          message
        };
        showErrorMessageInfo(messageBar);
      }
      deleteProductAttributionToken(code)
    })
    .catch(error => {
      console.log(error);
    });
};

export default deleteFromCartAndAddToWishlist;
